import { useLayoutEffect as e, useEffect as o } from "react";
const t = typeof window < "u" ? e : o;
export {
  t as u
};
//# sourceMappingURL=use-isomorphic-layout-effect.BGfaCOP1.js.map
